import { Printer } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { triggerPrint, type EntityRef } from '@/lib/export';

/**
 * SP5 Quick PDF Export — the only interactive affordance in the export path.
 *
 * Renders a small "Export PDF" outline button with a printer icon. On click,
 * delegates to `triggerPrint(entity)` which swaps `document.title` to the
 * target filename and invokes `window.print()`. The `data-no-print` attribute
 * hides the button itself from the print layout (see `styles/print.css`).
 */
export function ExportButton({ entity }: { entity: EntityRef }) {
  const friendlyType =
    entity.type === 'ThreatActor' ? 'threat actor' : entity.type.toLowerCase();
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={() => triggerPrint(entity)}
      aria-label={`Export this ${friendlyType} as PDF`}
      data-no-print
      className="gap-2"
    >
      <Printer size={16} aria-hidden="true" />
      Export PDF
    </Button>
  );
}
